// frontend_react/src/services/accountingApi.js

import api, { buildCompanyScopeHeaders } from "./api";

export const getExportHistory = async () => {
  throw new Error("Endpoint manquant côté backend: GET /api/exports/history");
};

export const generateFec = ({ companyUuid } = {}) =>
  api.get("/accounting/fec", {
    responseType: "blob",
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const generateSaft = ({ companyUuid } = {}) =>
  api.get("/accounting/saf-t", {
    responseType: "blob",
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const exportCsv = ({ companyUuid } = {}) =>
  api.get("/accounting/fec", {
    responseType: "blob",
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const fetchAccountCodes = ({
  companyUuid,
  category,
  subcategory,
} = {}) =>
  api.get("/accounting/account-codes", {
    params: {
      ...(category
        ? { category }
        : {}),
      ...(subcategory
        ? { subcategory }
        : {}),
    },
    headers: buildCompanyScopeHeaders(
      companyUuid
    ),
  });

export const fetchAccountingEntries = ({ companyUuid, ...params } = {}) =>
  api.get("/accounting/entries", {
    params,
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const downloadAccountingEntriesCsv = ({ companyUuid } = {}) =>
  api.get("/accounting/entries/csv", {
    responseType: "blob",
    headers: buildCompanyScopeHeaders(companyUuid),
  });